import { createContext, useContext } from "react";

/**
 * Permissão de EXCLUIR, resolvida uma vez no login (GET /api/me) e distribuída
 * para a árvore. Quem decide é o servidor; isto existe só para a tela não
 * oferecer um botão que voltaria 403.
 */
const Ctx = createContext(false);

export const PermissoesProvider = Ctx.Provider;

/** Só administradores podem excluir registros (regra do Portal). */
export const usePodeExcluir = () => useContext(Ctx);
